import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_AGENT_CAPACITY_TYPES = createAsyncActionTypes('FETCH_AGENT_CAPACITY');
export const FETCH_PORTAL_CAPACITY_LIMITS_TYPES = createAsyncActionTypes('FETCH_PORTAL_CAPACITY_LIMITS');
export const UPDATE_CAPACITY_LIMIT = 'UPDATE_CAPACITY_LIMIT';